<template>
	<form @submit="onSubmit" id="ForgotPasswordForm" class="mt-2 forgot-password">
		<div v-if="step < 4">
			<div v-if="step==1">
				<div class="text-center">
					<label class="d-block">جهت بازیابی رمز عبور لطفا کد ملی خود را وارد نمایید</label>
				</div>
				<div class="col-12 mb-2">
					<label for="code">کد ملی</label>
					<input type="text" class="form-control" id="nationalCode"
						   v-model="nationalCode"
						   inputmode="numeric"
						   data-label="کد ملی"
						   data-validations='["required","nationalcode"]' />
				</div>
			</div>
			<div v-if="step==2">
				<div class="text-center">
					<label class="d-block">کد اعتبار سنجی به شماره موبایل {{ mobile }} ارسال شد.</label>
				</div>
				<div class="col-12 mb-2">
					<label>کد اعتبارسنجی</label>
					<input type="text" class="form-control"
						   v-model="authCode"
						   inputmode="numeric"
						   data-label="کد اعتبارسنجی"
						   data-validations='["required","number"]' />
				</div>
			</div>
			<div v-if="step==3">
				<div class="text-center">
					<label class="d-block">کلمه عبور جدید را وارد نمایید</label>
				</div>
				<div class="col-12 mb-2">
					<label>کلمه عبور</label>
					<input type="password" class="form-control"
						   v-model="password"
						   data-label="کلمه عبور"
						   data-validations='["required","password"]' />
				</div>
				<div class="col-12 mb-2">
					<label>تکرار کلمه عبور</label>
					<input type="password" class="form-control"
						   v-model="repeatPassword"
						   data-label="تکرار کلمه عبور"
						   data-validations='["required","password"]' />
				</div>
			</div>
			<div class="alert alert-warning m-0" v-if="warnings.length">
				<label></label>
				<ul>
					<li v-for="warning in warnings">
						{{ $t(warning.type,{label:warning.label}) }}
					</li>
				</ul>
			</div>
			<div class="alert alert-danger m-0" v-if="errors.length">
				<label></label>
				<ul>
					<li v-for="error in errors">
						{{ $t(error.type) }}
					</li>
				</ul>
			</div>
			<div class="col-12 pr-0 pl-0 mt-2 float-right">
				<div class="row">
					<div class="col-2 pe-0">
						<button class="btn  btn-back" type="button" @click="onPrev">
							بازگشت
						</button>
					</div>
					<div class="col-10">
						<button class="btn btn-continue" type="submit" v-bind:disabled="loading">
							<span v-if="!loading">ادامه</span>
							<span v-if="loading" class="spinner-border spinner-border-sm"></span>
						</button>
					</div>
				</div>
			</div>
		</div>
	</form>
</template>
<script>
	import store from "@/common/store";
	import utility from '@/plugins/utility';
	const form = new utility.form('#ForgotPasswordForm');

	export default {
		data()
		{
			return {
				step: 1,
				customer: {},
				loading: false,
				warnings: [],
				errors: [],
				nationalCode: '',
				password: '',
				repeatPassword: '',
				authCode: '',
			}
		},

		methods: {

			gotoClub()
			{
				this.request('/api/Club/GetCustomerInfo', null, (response) =>
				{
					if (response)
					{
						store.customer = response
						const redirectPath = this.$route.query.redirect || "/club/dashboard";
						this.$router.push(redirectPath);
					}
					else
					{
						this.errors = [{ type: 'errors.server' }];
					}

				}, 'get');
			},

			changeType(value)
			{
				this.$emit('changeType', value)
			},

			onSubmit(evt)
			{
				var self = this;
				evt.preventDefault()
				this.warnings = form.errors();
				this.errors = [];

				if (this.warnings.length == 0)
				{
					if (this.step == 1)
					{
						this.request('/api/CustomerAuth/CheckNationalCode', { NationalCode: this.nationalCode, ApiRequestType: 'ForgetPassword' }, (response) =>
						{
							if (response.success)
							{
								if (response.meta.customer != undefined)
								{
									this.fullName = response.meta.customer.fullName;
									this.mobile = response.meta.customer.mobile;
								}

								if (response.meta.message == "Active Customer Found")
								{
									this.step = 2;
								}
								else
								{
									this.warnings.push({ type: 'validation.nationalCodeNotFound' })
								}
							}
						})
					}

					else if (this.step == 2)
					{
						this.request('/api/CustomerAuth/CheckAuthCode', { NationalCode: this.nationalCode, AuthCode: this.authCode }, (response) =>
						{
							if (response.success)
							{
								this.step = 3;
							}
							else
							{
								this.warnings = [{ type: 'validation.auth' }];
							}

						})
					}

					else if (this.step == 3)
					{
						if (this.password == this.repeatPassword)
						{
							this.request('/api/CustomerAuth/ResetPassword',
								{
									NationalCode: this.nationalCode,
									AuthCode: this.authCode,
									PassWord: this.password
								},
								(response) =>
								{
									if (response.success)
									{
										axios({
											method: 'post',
											url: '/login',
											headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
											data: 'username=' + this.nationalCode + '&password=' + this.password + '&grant_type=password&customer=1'
										})
											.then(response =>
											{
												this.loading = false;
												if (response.data !== undefined)
												{
													if (response.data.access_token !== undefined)
													{
														store.token = response.data
														if (this.rememberMe)
															db.insert('__t', response.data);

														axios.defaults.headers.common['Authorization'] =
															'Bearer ' + store.token.access_token;

														this.gotoClub()
														return;
													}
												}

												this.errors = [{ type: 'errors.server' }];
											})
											.catch(error =>
											{
												this.loading = false;
												this.errors = [{ type: 'errors.server' }];
											});
									}
									else this.errors.push({ type: 'errors.noAccess' })
								})
						}
						else
						{
							this.warnings.push({ type: 'validation.repeatPassword' })
						}
					}
				}
			},

			request(url, data, succees, method)
			{
				this.loading = true;
				axios({
					method: method || 'post',
					url: url,
					data: data
				})
					.then(response =>
					{
						this.loading = false;
						succees(response.data)
					})
					.catch(error =>
					{
						this.errors = [{ type: 'errors.server' }];
						this.loading = false;
					});
			},


			onPrev()
			{
				this.errors = []
				if (this.step == 1)
				{
					this.$emit('stateChanged', 'login')

				} else
				{
					this.step -= 1
				}
			}
		}
	};
</script>
<style>
	.forgot-password .btn-continue {
		height: 45px;
		color: #000;
		background-color: #ffc600;
		width: 100%;
		transition: all 0.5s;
		outline: none;
		-webkit-box-shadow: none;
		box-shadow: none;
		transition: all .5s;
	}

		.forgot-password .btn-continue:hover {
			background-color: #fff;
			box-shadow: 0px 0px 10px 0px #ddd;
			color: #ffc600;
			transition: all .5s;
		}

	.forgot-password .btn-back {
		color: #000;
		background-color: #fff;
		border: 1px solid #ddd;
		width: 100%;
		height: 45px;
		transition: all 0.5s;
		outline: none;
		-webkit-box-shadow: none;
		box-shadow: none;
	}
</style>
